const sanitizeButtons = buttons =>
  (Array.isArray(buttons) ? buttons : [])
    .map(button => ({
      text: (button?.text || '').toString().trim(),
      url: (button?.url || '').toString().trim(),
      openInAppPopup: Boolean(
        button?.openInAppPopup || button?.open_in_app_popup || false
      ),
    }))
    .filter(button => button.text && button.url)
    .slice(0, 8);

const defaultButtonsStorageKey = accountId =>
  `telegram-default-action-buttons:${accountId || 'global'}`;

export const loadDefaultActionButtons = accountId => {
  if (typeof window === 'undefined') return [];

  try {
    const raw = window.localStorage.getItem(
      defaultButtonsStorageKey(accountId)
    );
    return sanitizeButtons(raw ? JSON.parse(raw) : []);
  } catch (_error) {
    return [];
  }
};

export const saveDefaultActionButtons = (accountId, buttons) => {
  if (typeof window === 'undefined') return;

  const sanitized = sanitizeButtons(buttons);
  window.localStorage.setItem(
    defaultButtonsStorageKey(accountId),
    JSON.stringify(sanitized)
  );
};

export const normalizeDefaultButtons = buttons => sanitizeButtons(buttons);
